<template>
  <div v-click-outside="closeSelectbox">
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <div
      class="relative w-full h-10 bg-white border cursor-pointer"
      :class="{ 'border-danger': errorMessage }"
      style="border-radius: 4px"
    >
      <div class="selectbox" @click="toggleSelectbox">
        <span v-if="!value">選択して下さい</span>
        <span
          v-else
          v-for="option in options"
          v-show="option.id === value"
          :key="option.id"
        >
          {{
            optionFormatType === 'number'
              ? amountFormatter(option.name)
              : option.name
          }}{{ unit }}
        </span>
      </div>

      <div class="selector" v-show="isOpen">
        <div
          v-for="option in options"
          :key="option.id"
          class="selector-option"
          :class="{ 'text-gray-92': value === option.id }"
          @click="onChange(option.id), closeSelectbox()"
        >
          {{
            optionFormatType === 'number'
              ? amountFormatter(option.name)
              : option.name
          }}{{ unit }}
        </div>
      </div>
    </div>

    <select v-bind="field" :name="name" class="hidden">
      <option v-for="option in options" :key="option.id" :value="option.id" />
    </select>

    <BaseErrorMessage v-if="errorMessage" :message="errorMessage" />
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue';

import { amountFormatter } from '@/utils/filters.js';
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    BaseFormLabel,
    BaseErrorMessage,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
    },
    optionFormatType: String,
    unit: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    field: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {
    const state = reactive({
      isOpen: false,
    });

    const closeSelectbox = () => {
      state.isOpen = false;
    };

    const toggleSelectbox = () => {
      state.isOpen = !state.isOpen;
    };

    return {
      ...toRefs(state),
      amountFormatter,
      closeSelectbox,
      toggleSelectbox,
    };
  },
};
</script>

<style lang="scss" scoped>
.selectbox {
  @apply h-10 leading-10 px-4;

  &:after {
    content: '';
    top: 18px;
    width: 11px;
    height: 11px;
    border: 5.5px solid transparent;
    border-top: 5.5px solid rgba(6, 16, 26, 0.92); // border-gray-92
    @apply absolute right-4;
  }
}

.selector {
  max-height: 356px;
  border-radius: 8px;
  box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3);
  @apply absolute top-10 left-0 bg-white w-full py-4 overflow-y-scroll z-20;
}

.selector-option {
  @apply text-gray-62 relative flex items-center justify-between w-full px-4 leading-8 hover:text-gray-92;

  &:hover {
    background: #f1f2f6;
  }
}
</style>
